import { resultsTxtData_de, resultsTxtData_en } from '../../shared/Lang/ResultsTxt'

export const histLayout = (histogramData, isMobile) => ({
  // width: isMobile ? 500 : 900,
  // height: isMobile ? 200 : 600,
  autosize: true,
  margin: {
    l: 40,
    r: 20,
    b: 80,
    t: 20,
    pad: 0
  },
  // title: 'Normalized Histogram',
  xaxis: {
    dtick: isMobile ? 10 : 5,
    range: [0, histogramData.maxBin],
    title: 'Value',
    // tickvals: histogramData.xTicks,
    // ticktext: histogramData.xTicks.map(val => val.toString()),
    tickangle: 0,
    ticklen: 5,
    tickfont: {
      size: 8    // font-size
    }
  },
  yaxis: {
    title: 'Percentage (%)', tickfont: {
      size: 10
    }
  },
})


export const lineOptions = (allWPM, allInput) => ({
  scales: {
    x: {
      type: "linear", // Use a categorical axis for Sentence IDs
      beginAtZero: true,
      grid: {
        display: false,
      },
      ticks: {
        stepSize: 1,
        min: 1,
        max: allWPM.length, // Adjust this value based on the number of sentences
        maxTicksLimit: allWPM.length,
      },
      title: {
        display: true,
        text: 'Sentence'
      },
    },
    y: {
      beginAtZero: true,
      type: "linear",
      position: "left",
      grid: {
        display: true,
      },
      ticks: {
        stepSize: 10,
        min: 0,
        max: 100, // Adjust this value based on your WPM data range
      },
      title: {
        display: true,
        text: 'WPM'
      },
    },
    y1: {
      beginAtZero: true,
      type: "linear",
      display: true,
      position: "right", // 👈 Error Rate on the right
      grid: { drawOnChartArea: false }, // keep grid clean
      title: { display: true, text: "Error Rate (%)" },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        title: function (context) {
          const index = context[0].dataIndex; // data point index
          // return `Test #${index + 1}`;   // custom title
          return ''; // 👈 empty string removes the title
        },
        label: function (context) {
          const index = context.dataIndex;
          console.log(index, "ind", context.dataset.label, '....')
          if (context.dataset.label === "WPM") {
            // return `Sentence: ${allInput[index]}`;
            return [
              `WPM: ${parseInt(allWPM[index])}`,      // line 1
              `Sentence: ${allInput[index]}`          // line 2
            ]
          }
          else {
            return [`Error Rate: ${context.formattedValue}%`, `Sentence: ${allInput[index]}`];
          }
          // return `Sentence: ${allInput[index]}`;
        }
      }
    }
  }
})

export const resultBarData = (isMobile, lang, wpm, backspace, errRate) => {
  const translations = {
    English: resultsTxtData_en,
    Deutsch: resultsTxtData_de
  }

  // fallback to English if language is missing
  const t = translations[lang] || resultsTxtData_en;

  return [
    {
      title: t.resultBar.device,
      val: isMobile ? 'Mobile' : 'Desktop' // or t.deviceMobile / t.deviceDesktop if you add them
    },
    {
      title: t.resultBar.lang,
      val: lang
    },
    {
      title: t.resultBar.wpm,
      val: wpm
    },
    {
      title: t.resultBar.backspace,
      val: backspace
    },
    {
      title: t.resultBar.errRate,
      val: errRate
    }
  ];

}

export const resHighData = (restultPageLang, histogramData) => ([
  {
    heading: restultPageLang.maxwpm.heading,
    errors: restultPageLang.maxwpm.errors,
    errVal: histogramData.maxWPM[1],
    wpm: restultPageLang.maxwpm.wpm,
    wpmVal: parseInt(histogramData.maxWPM[2]),
    sentence: histogramData.maxWPM[0]
  },
  {
    heading: restultPageLang.minWpm.heading,
    errors: restultPageLang.minWpm.errors,
    errVal: histogramData.minWPM[1],
    wpm: restultPageLang.minWpm.wpm,
    wpmVal: parseInt(histogramData.minWPM[2]),
    sentence: histogramData.minWPM[0]
  },
  {
    heading: restultPageLang.maxerrorrate.heading,
    errors: restultPageLang.maxerrorrate.errors,
    errVal: histogramData.maxErrRate[2],
    wpm: restultPageLang.maxerrorrate.wpm,
    wpmVal: parseInt(histogramData.maxErrRate[3]),
    sentence: histogramData.maxErrRate[0],
    correctSentence: histogramData.maxErrRate[1]
  }
])
